<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="#" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <h2>Smart Energy Systems</h2>


        <p>Energy systems will become smart to meet the requirement of a stable electricity supply even when the energy
          sources, such as wind- and solar power, are highly volatile. This will enable a 100% electricity supply by
          <span class="versa">RENEWABLE ENERGIES</span> for most countries in the world. Furthermore smart energy
          systems are needed to make the overall system more <span class="versa">EFFICIENT</span> in order to reduce use
          of resources and capital.
          To achieve this, smart devices are necessary to interconnect renewable energies with the grid operation and
          <span class="versa">SMART CONSUMERS</span>. Smart consumers will be especially large <span class="versa">INDUSTRIAL</span> or <span class="versa">COMMERCIAL</span> facilities, <span class="versa">ELECTRIC VEHICLES</span> and other types
          of <span class="versa">STORAGE</span> [Not the so called smart meter for end customers]. The matching of
          supply and demand for energy will happen automatically and will not involve a change of usage patterns for
          end customers. Thereby it also constitutes the first complete application case of the <span class="versa">Digitalization</span>
          of a whole industry.
        </p>

        <p>To foster the introduction of <span class="versa">SMART ENERGY SYSTEMS</span> we provide consulting solutions
          for the following
          areas:</p>
        <ul>
          <li>Industrial Micro Smart Grids – Renewable, reliable and sustainable onsite generation</li>
          <li>Economic optimization of industrial energy consumption</li>
          <li>Energy management solutions</li>
          <li>Future energy system and market design for 100% renewables</li>
        </ul>
        <h2>Smart Energy project activity</h2>
        <ul class="years">
          <li><span>2015</span>Organization of <a href="//www.eitdigital.eu/sec2015/" target="_blank">Smart Energy Community
            Conference</a>
          </li>
          <li><span>2014-2015</span>Development of a decentralized energy supply strategy for a large industrial
            consumer in the context of the “Energiewende” (Industrial Micro Smart Grids) – incl. flexible energy
            management platform for multiple use cases
          </li>
          <li><span>2014</span>Co-founder of <a
            href="//www.eitdigital.eu/innovation-entrepreneurship/smart-energy-systems/smart-energy-community-2014/" target="_blank">Smart
            Energy Community Conference</a></li>
          <li><span>2013</span>Project lead of <a href="//www.youtube.com/watch?v=-HesDRfiiKo" target="_blank">“Speicherstudie”</a> -
            a project to connect large uninterruptable power supply systems of a telecommunication provider to the
            frequency control of a large utility
          </li>
          <li><span>2012</span>Development of the pan European business area <a
            href="//www.eitdigital.eu/innovation-entrepreneurship/smart-energy-systems/" target="_blank">Smart Energy
            Systems</a> for EIT Digital
            together with the leading European research institutes, universities and industry actors
          </li>
          <li><span>2010</span>Smart Metering & Smart Grid in Germany – Technology Roadmap until 2020</li>
        </ul>
        <p class="end"></p>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    methods: {
      back () {
        window.history.go(-1)
      }},
    data: function () {
      return {
        title: 'Smart Energy Systems'
      }
    },
    // Usage with context the component
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        return {
          inner: this.title
        }
      },
      meta: [
        { name: 'description', content: 'My description', id: 'desc' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Smart.vue?651ea5c2